


import React from 'react'
import {Routes, Route, Navigate} from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import CarListing from '../pages/CarListing';
import CarDetails from '../pages/CarDetails';
import Blog from '../pages/Blog';
import BlogDetails from '../pages/BlogDetails';
import NotFound from '../pages/NotFound';
import Contact from '../pages/Contact';
import SignUp from '../SignUp/SignUp';
import Login from '../Login/Login';
import Privacy from '../pages/Privacy';
import Term from '../pages/Term';
import OneWayDrop from '../pages/OneWay';
import CarrentalKarachi from '../pages/carrentalkarachi';
import RentacarKarachi from '../pages/rentacarkarachi';
import RentacarFaisalabad from '../pages/rentacarFaisalabad';
import RentacarGujranwala from '../pages/rentacarGujranwala';
import RentacarIslamabad from '../pages/rentacarIslamabad';
import RentacarLahore from '../pages/rentacarLahore';
import RentacarPeshawar from '../pages/rentacarPeshawar';
import RentacarLarkana from '../pages/rentacarLarkana';
import RentacarPakistan from '../pages/rentacarPakistan';
import RentacarMultan from '../pages/rentacarMultan';


import Page1 from '../pages/Page (1)';
import Page2 from '../pages/Page (2)';
import Page3 from '../pages/Page (3)';
import Page4 from '../pages/Page (4)';
import Page5 from '../pages/Page (5)';
import Page6 from '../pages/Page (6)';
import Page7 from '../pages/Page (7)';
import Page8 from '../pages/Page (8)';
import Page9 from '../pages/Page (9)';
import Page10 from '../pages/Page (10)';
import Page11 from '../pages/Page (11)';
import Page12 from '../pages/Page (12)';
import Page13 from '../pages/Page (13)';
import Page14 from '../pages/Page (14)';
import Page15 from '../pages/Page (15)';
import Page16 from '../pages/Page (16)';
import Page17 from '../pages/Page (17)';
import Page18 from '../pages/Page (18)';
import Page19 from '../pages/Page (19)';
import Page20 from '../pages/Page (20)';
import Page21 from '../pages/Page (21)';
import Page22 from '../pages/Page (22)';
import Page23 from '../pages/Page (23)';
import Page24 from '../pages/Page (24)';
import Page25 from '../pages/Page (25)';
import Page26 from '../pages/Page (26)';
import Page27 from '../pages/Page (27)';
import Page28 from '../pages/Page (28)';
import Page29 from '../pages/Page (29)';
import Page30 from '../pages/Page (30)';
import Page31 from '../pages/Page (31)';
import Page32 from '../pages/Page (32)';
import Page33 from '../pages/Page (33)';
import Page34 from '../pages/Page (34)';
import Page35 from '../pages/Page (35)';
import Page36 from '../pages/Page (36)';
import Page37 from '../pages/Page (37)';
import Page38 from '../pages/Page (38)';
import Page39 from '../pages/Page (39)';
import Page40 from '../pages/Page (40)';
import Page41 from '../pages/Page (41)';
import Page42 from '../pages/Page (42)';
import Page43 from '../pages/Page (43)';
import Page44 from '../pages/Page (44)';
import Page45 from '../pages/Page (45)';
import Page46 from '../pages/Page (46)';
import Page47 from '../pages/Page (47)';
import Page48 from '../pages/Page (48)';
import Page49 from '../pages/Page (49)';

import Page50 from '../pages/Page (50)';
import Page51 from '../pages/Page (51)';
import Page52 from '../pages/Page (52)';
import Page53 from '../pages/Page (53)';
import Page54 from '../pages/Page (54)';
import Page55 from '../pages/Page (55)';
import Page56 from '../pages/Page (56)';
import Page57 from '../pages/Page (57)';
import Page58 from '../pages/Page (58)';
import Page59 from '../pages/Page (59)';
import Page60 from '../pages/Page (60)';
import Page61 from '../pages/Page (61)';
import Page62 from '../pages/Page (62)';
import Page63 from '../pages/Page (63)';
import Page64 from '../pages/Page (64)';
import Page65 from '../pages/Page (65)';
import Page66 from '../pages/Page (66)';
import Page67 from '../pages/Page (67)';
import Page68 from '../pages/Page (68)';
import Page69 from '../pages/Page (69)';


import Page70 from '../pages/Page (70)';
import Page71 from '../pages/Page (71)';
import Page72 from '../pages/Page (72)';
import Page73 from '../pages/Page (73)';
import Page74 from '../pages/Page (74)';
import Page75 from '../pages/Page (75)';
import Page76 from '../pages/Page (76)';
import Page77 from '../pages/Page (77)';
import Page78 from '../pages/Page (78)';
import Page79 from '../pages/Page (79)';
import Page80 from '../pages/Page (80)';
import Page81 from '../pages/Page (81)';
import Page82 from '../pages/Page (82)';
import Page83 from '../pages/Page (83)';
import Page84 from '../pages/Page (84)';
import Page85 from '../pages/Page (85)';
import Page86 from '../pages/Page (86)';
import Page87 from '../pages/Page (87)';
import Page88 from '../pages/Page (88)';
import Page89 from '../pages/Page (89)';
import Page90 from '../pages/Page (90)';
import Page91 from '../pages/Page (91)';
import Page92 from '../pages/Page (92)';
import Page93 from '../pages/Page (93)';
import Page94 from '../pages/Page (94)';
import Page95 from '../pages/Page (95)';
import Page96 from '../pages/Page (96)';
import Page97 from '../pages/Page (97)';
import Page98 from '../pages/Page (98)';
import Page99 from '../pages/Page (99)';
import Page100 from '../pages/Page (100)';
import Page101 from '../pages/Page (101)';
import Page102 from '../pages/Page (102)';
import Page103 from '../pages/Page (103)';
import Page104 from '../pages/Page (104)';
import Page105 from '../pages/Page (105)';
import Page106 from '../pages/Page (106)';
import Page107 from '../pages/Page (107)';
import Page108 from '../pages/Page (108)';
import Page109 from '../pages/Page (109)';
import Page110 from '../pages/Page (110)';
import Page111 from '../pages/Page (111)';
import Page112 from '../pages/Page (112)';
import Page113 from '../pages/Page (113)';
import Page114 from '../pages/Page (114)';
import Page115 from '../pages/Page (115)';
import Page116 from '../pages/Page (116)';
import Page117 from '../pages/Page (117)';
import Page118 from '../pages/Page (118)';
import Page119 from '../pages/Page (119)';
import Page120 from '../pages/Page (120)';
import Page121 from '../pages/Page (121)';
import Page122 from '../pages/Page (122)';
import Page123 from '../pages/Page (123)';
import Page124 from '../pages/Page (124)';
import Page125 from '../pages/Page (125)';
import Page126 from '../pages/Page (126)';

import Page128 from '../pages/Page (128)';
import Page129 from '../pages/Page (129)';
import Page130 from '../pages/Page (130)';
import Page131 from '../pages/Page (131)';
import Page132 from '../pages/Page (132)';
import Page133 from '../pages/Page (133)';
import Page134 from '../pages/Page (134)';
import Page135 from '../pages/Page (135)';
import Page136 from '../pages/Page (136)';
import Page137 from '../pages/Page (137)';
import Page138 from '../pages/Page (138)';
import Page139 from '../pages/Page (139)';
import Page140 from '../pages/Page (140)';
import Page141 from '../pages/Page (141)';
import Page142 from '../pages/Page (142)';
import Page143 from '../pages/Page (143)';
import Page144 from '../pages/Page (144)';
import Page145 from '../pages/Page (145)';
import Page146 from '../pages/Page (146)';
import Page147 from '../pages/Page (147)';


const Routers = () => {
  return (
    <Routes>
        <Route path='/' element={<Navigate to = '/home'/>}></Route>
        <Route path='/home' element={<Home/>}></Route>
        <Route path='/about' element={<About/>}></Route>
        <Route path='/cars' element={<CarListing/>}></Route>
        <Route path='/cars/:slug' element={<CarDetails/>}></Route>
        <Route path='/blogs' element={<Blog/>}></Route>
        <Route path='/blogs/:slug' element={<BlogDetails/>}></Route>
        <Route path='/contact' element={<Contact/>}></Route>
        <Route path='/signup' element={<SignUp/>}></Route>
        <Route path='/login' element={<Login/>}></Route>
        <Route path='/privacy' element={<Privacy/>}></Route>
        <Route path='/onewaydrop' element={<OneWayDrop/>}></Route>
        <Route path='/term' element={<Term/>}></Route>
        <Route  path='/car-rental-in-karachi-pakistan' element={<CarrentalKarachi/>} />
        <Route  path='/rent-a-car-in-karachi' element={<RentacarKarachi/>} />
          <Route  path='/rent-a-car-in-Faisalabad' element={<RentacarFaisalabad/>} />
          <Route  path='/rent-a-car-in-Gujranwala' element={<RentacarGujranwala/>} />
          <Route  path='/rent-a-car-in-Islamabad' element={<RentacarIslamabad/>} />
          <Route  path='/rent-a-car-in-Lahore' element={<RentacarLahore/>} />
          <Route  path='/rent-a-car-in-Multan' element={<RentacarMultan/>} />
          <Route  path='/rent-a-car-in-Peshawar' element={<RentacarPeshawar/>} />
         
          <Route  path='/rent-a-car-in-Larkana' element={<RentacarLarkana/>} />
          <Route  path='/rent-a-car-in-Pakistan' element={<RentacarPakistan/>} />





<Route exact path="/rent-a-car-in-bahria-town-phase-1-8-with-driver" element={<Page1/>} />
<Route exact path="/rent-a-car-in-dha-islamabad-with-driver" element={<Page2/>} />
<Route exact path="/rent-a-car-in-gulberg-greens-with-driver" element={<Page3/>} />
<Route exact path="/rent-a-car-in-gulberg-residencia-with-driver" element={<Page4/>} />
<Route exact path="/rent-a-car-in-park-view-city-with-driver" element={<Page5/>} />
<Route exact path="/rent-a-car-in-top-city-1-with-driver" element={<Page6/>} />
<Route exact path="/rent-a-car-in-capital-smart-city-with-driver" element={<Page7/>} />
<Route exact path="/rent-a-car-in-pwd-housing-society-with-driver" element={<Page8/>} />
<Route exact path="/rent-a-car-in-naval-anchorage-with-driver" element={<Page9/>} />
<Route exact path="/rent-a-car-in-soan-gardens-with-driver" element={<Page10/>} />
<Route exact path="/rent-a-car-in-ghauri-town-with-driver" element={<Page11/>} />
<Route exact path="/rent-a-car-in-bani-gala-with-driver" element={<Page12/>} />
<Route exact path="/rent-a-car-in-tarnol-with-driver" element={<Page13/>} />
<Route exact path="/rent-a-car-in-chak-shahzad-with-driver" element={<Page14/>} />
<Route exact path="/rent-a-car-in-g-15-markaz-with-driver" element={<Page15/>} />
<Route exact path="/rent-a-car-in-fazaia-housing-society-with-driver" element={<Page16/>} />
<Route exact path="/rent-a-car-in-mpchs-multi-gardens-b-17-with-driver" element={<Page17/>} />
<Route exact path="/rent-a-car-in-jinnah-gardens-with-driver" element={<Page18/>} />
<Route exact path="/rent-a-car-in-national-police-foundation-npf-with-driver" element={<Page19/>} />
<Route exact path="/rent-a-car-in-eighteen-islamabad-with-driver" element={<Page20/>} />
<Route exact path="/rent-a-car-in-margalla-town-with-driver" element={<Page21/>} />
<Route exact path="/rent-a-car-in-alipur-farash-with-driver" element={<Page22/>} />
<Route exact path="/rent-a-car-in-fmc-faisal-margalla-city-with-driver" element={<Page23/>} />
<Route exact path="/rent-a-car-in-airport-green-garden-with-driver" element={<Page24/>} />
<Route exact path="/rent-a-car-in-gulshan-e-sehat-e-18-with-driver" element={<Page25/>} />
<Route exact path="/rent-a-car-in-swat-with-driver" element={<Page26 />} />
<Route exact path="/rent-a-car-in-kalam-with-driver" element={<Page27 />} />
<Route exact path="/rent-a-car-in-malam-jabba-with-driver" element={<Page28 />} />
<Route exact path="/rent-a-car-in-abbottabad-with-driver" element={<Page29 />} />
<Route exact path="/rent-a-car-in-kashmir-with-driver" element={<Page30 />} />
<Route exact path="/rent-a-car-in-naran-with-driver" element={<Page31 />} />
<Route exact path="/rent-a-car-in-ghan-with-driver" element={<Page32 />} />
<Route exact path="/rent-a-car-in-murree-with-driver" element={<Page33 />} />
<Route exact path="/rent-a-car-in-hunza-with-driver" element={<Page34 />} />
<Route exact path="/rent-a-car-in-gilgit-with-driver" element={<Page35 />} />
<Route exact path="/rent-a-car-in-kaghan-with-driver" element={<Page36 />} />
<Route exact path="/rent-a-car-in-naltar-with-driver" element={<Page37 />} />
<Route exact path="/rent-a-car-in-shandur-with-driver" element={<Page38 />} />
<Route exact path="/rent-a-car-in-skardu-with-driver" element={<Page39 />} />
<Route exact path="/rent-a-car-in-chitral-with-driver" element={<Page40 />} />
<Route exact path="/rent-a-car-in-fairy-meadows-with-driver" element={<Page41 />} />
<Route exact path="/rent-a-car-in-neelum-valley-with-driver" element={<Page42 />} />
<Route exact path="/rent-a-car-in-balakot-with-driver" element={<Page43 />} />
<Route exact path="/rent-a-car-in-thandiani-with-driver" element={<Page44 />} />
<Route exact path="/rent-a-car-in-ayubia-with-driver" element={<Page45 />} />
<Route exact path="/rent-a-car-in-khunjerab-pass-with-driver" element={<Page46 />} />
<Route exact path="/rent-a-car-in-ramkot-fort-with-driver" element={<Page47 />} />
<Route exact path="/rent-a-car-in-kotli-with-driver" element={<Page48 />} />
<Route exact path="/rent-a-car-in-jhelum-with-driver" element={<Page49 />} />

<Route exact path="/rent-a-car-in-dha-lahore" element={<Page50 />} />
<Route exact path="/rent-a-car-in-gulberg-lahore" element={<Page51 />} />
<Route exact path="/rent-a-car-in-model-town-lahore" element={<Page52 />} />
<Route exact path="/rent-a-car-in-bahria-town-lahore" element={<Page53 />} />
<Route exact path="/rent-a-car-in-johar-town-lahore" element={<Page54 />} />
<Route exact path="/rent-a-car-in-garden-town-lahore" element={<Page55 />} />
<Route exact path="/rent-a-car-in-iqbal-town-lahore" element={<Page56 />} />
<Route exact path="/rent-a-car-in-cantt-lahore" element={<Page57 />} />
<Route exact path="/rent-a-car-in-faisal-town-lahore" element={<Page58 />} />
<Route exact path="/rent-a-car-in-shadman-lahore" element={<Page59 />} />
<Route exact path="/rent-a-car-in-shalimar-lahore" element={<Page60 />} />
<Route exact path="/rent-a-car-in-wapda-town-lahore" element={<Page61 />} />
<Route exact path="/rent-a-car-in-valencia-town-lahore" element={<Page62 />} />
<Route exact path="/rent-a-car-in-askari-housing-lahore" element={<Page63 />} />
<Route exact path="/rent-a-car-in-township-lahore" element={<Page64 />} />
<Route exact path="/rent-a-car-in-muslim-town-lahore" element={<Page65 />} />
<Route exact path="/rent-a-car-in-samnabad-lahore" element={<Page66 />} />
<Route exact path="/rent-a-car-in-hall-road-lahore" element={<Page67 />} />
<Route exact path="/rent-a-car-in-mall-road-lahore" element={<Page68 />} />
<Route exact path="/rent-a-car-in-fortress-stadium-lahore" element={<Page69 />} />



<Route exact path="/rent-toyota-coaster-5c-saloon-islamabad" element={<Page70 />} />
<Route exact path="/rent-mercedes-benz-c-class-cars-islamabad" element={<Page71 />} />
<Route exact path="/rent-audi-a4-45-tfsi-islamabad" element={<Page72 />} />
<Route exact path="/rent-yaris-crolla-islamabad" element={<Page73 />} />
<Route exact path="/rent-toyota-coaster-4c-saloon-islamabad" element={<Page74 />} />
<Route exact path="/rent-toyota-prado-tx-l-package-2-7-islamabad" element={<Page75 />} />
<Route exact path="/rent-limousine-car-islamabad" element={<Page76 />} />
<Route exact path="/rent-toyota-hilux-revo-2021-islamabad" element={<Page77 />} />
<Route exact path="/rent-toyota-land-cruiser-v8-islamabad" element={<Page78 />} />
<Route exact path="/rent-toyota-corolla-altis-grande-x-cvt-i-1-8-islamabad" element={<Page79 />} />
<Route exact path="/rent-honda-civic-2023-islamabad" element={<Page80 />} />
<Route exact path="/rent-bmw-islamabad" element={<Page81 />} />
<Route exact path="/rent-toyota-hiace-grand-cabin-224-islamabad" element={<Page82 />} />
<Route exact path="/rent-glory-islamabad" element={<Page83 />} />
<Route exact path="/rent-daihatsu-copen-robe-islamabad" element={<Page84 />} />
<Route exact path="/rent-toyota-corolla-altis-x-automatic-1-6-islamabad" element={<Page85 />} />
<Route exact path="/rent-honda-civic-oriel-1-8-i-vtec-cvt-2021-islamabad" element={<Page86 />} />
<Route exact path="/rent-toyota-fortuner-legender-limited-islamabad" element={<Page87 />} />
<Route exact path="/rent-toyota-corolla-gli-1-3-vvti-2020-islamabad" element={<Page88 />} />
<Route exact path="/rent-toyota-corolla-altis-x-automatic-1-6-islamabad" element={<Page89 />} />
<Route exact path="/rent-honda-br-v-i-vtec-s-islamabad" element={<Page90 />} />
<Route exact path="/rent-toyota-voxy-7-seater-hybrid-islamabad" element={<Page91 />} />
<Route exact path="/rent-suzuki-cultus-vxr-2022-islamabad" element={<Page92 />} />
<Route exact path="/rent-suzuki-alto-2022-islamabad" element={<Page93 />} />
<Route exact path="/rent-suzuki-apv-islamabad" element={<Page94 />} />
<Route exact path="/rent-you-strong-bus-43-seater-islamabad" element={<Page95 />} />
<Route exact path="/rent-chinga-karvan-7-seater-islamabad" element={<Page96 />} />





<Route exact path="/chauffeur-car-islamabad" element={<Page97 />} />
<Route exact path="/luxury-car-hire-driver" element={<Page98 />} />
<Route exact path="/car-rental-with-driver-isb" element={<Page99 />} />
<Route exact path="/rent-a-car-islamabad-driver" element={<Page100 />} />
<Route exact path="/24-7-car-rental-driver" element={<Page101 />} />
<Route exact path="/executive-car-rental" element={<Page102 />} />
<Route exact path="/safe-car-hire-pakistan" element={<Page103 />} />
<Route exact path="/suv-rent-with-driver" element={<Page104 />} />
<Route exact path="/family-corporate-car-rental" element={<Page105 />} />
<Route exact path="/outstation-car-rental" element={<Page106 />} />
<Route exact path="/northern-areas-car-rental" element={<Page107 />} />
<Route exact path="/long-route-car-hire" element={<Page108 />} />
<Route exact path="/islamabad-airport-transfer" element={<Page109 />} />
<Route exact path="/wedding-car-rental-isb" element={<Page110 />} />
<Route exact path="/business-class-car-rental" element={<Page111 />} />
<Route exact path="/monthly-daily-car-rent" element={<Page112 />} />
<Route exact path="/tourist-car-rental-pakistan" element={<Page113 />} />
<Route exact path="/luxury-travel-driver" element={<Page114 />} />
<Route exact path="/4x4-car-rental-driver" element={<Page115 />} />
<Route exact path="/car-rental-foreign-tourists" element={<Page116 />} />
<Route exact path="/chauffeur-suv-rental" element={<Page117 />} />
<Route exact path="/corporate-fleet-rental" element={<Page118 />} />
<Route exact path="/vip-protocol-transport" element={<Page119 />} />
<Route exact path="/city-to-city-car-rental" element={<Page120 />} />
<Route exact path="/family-tour-car-rental" element={<Page121 />} />
<Route exact path="/chauffeur-long-distance" element={<Page122 />} />
<Route exact path="/tour-event-car-rental" element={<Page123 />} />
<Route exact path="/best-car-rental-islamabad" element={<Page124 />} />
<Route exact path="/luxury-economy-car-rent" element={<Page125 />} />
<Route exact path="/trusted-car-hire-pakistan" element={<Page126 />} />



<Route exact path="/rent-a-car-in-blue-area-islamabad" element={<Page128 />} />
<Route exact path="/rent-a-car-in-f-6-islamabad" element={<Page129 />} />
<Route exact path="/rent-a-car-in-f-7-islamabad" element={<Page130 />} />
<Route exact path="/rent-a-car-in-f-8-islamabad" element={<Page131 />} />
<Route exact path="/rent-a-car-in-f-10-islamabad" element={<Page132 />} />
<Route exact path="/rent-a-car-in-f-11-islamabad" element={<Page133 />} />
<Route exact path="/rent-a-car-in-g-5-islamabad" element={<Page134 />} />
<Route exact path="/rent-a-car-in-g-6-islamabad" element={<Page135 />} />
<Route exact path="/rent-a-car-in-g-7-islamabad" element={<Page136 />} />
<Route exact path="/rent-a-car-in-g-8-islamabad" element={<Page137 />} />
<Route exact path="/rent-a-car-in-g-9-islamabad" element={<Page138 />} />
<Route exact path="/rent-a-car-in-g-10-islamabad" element={<Page139 />} />
<Route exact path="/rent-a-car-in-g-11-islamabad" element={<Page140 />} />
<Route exact path="/rent-a-car-in-i-8-islamabad" element={<Page141 />} />
<Route exact path="/rent-a-car-in-i-9-islamabad" element={<Page142 />} />
<Route exact path="/rent-a-car-in-i-10-islamabad" element={<Page143 />} />
<Route exact path="/rent-a-car-in-i-11-islamabad" element={<Page144 />} />
<Route exact path="/rent-a-car-in-e-11-islamabad" element={<Page145 />} />
<Route exact path="/rent-a-car-in-h-13-islamabad" element={<Page146 />} />
<Route exact path="/rent-a-car-in-rawat-islamabad" element={<Page147 />} />


        <Route path='*' element={<NotFound/>}></Route>
    </Routes>
  )
}

export default Routers